// REQ-P1-11: 本番JSエラーの収集(Sentry)。エラー監視のみ・PII非送信。
//
// 方針(AGENTS.md §14 プライバシールール準拠):
// - 送るのは「エラー内容・発生箇所・リリース情報」のみ。
//   sendDefaultPii無効 + beforeSendでメールアドレス様の文字列をマスクする。
// - DSN未設定(ローカル開発など)では完全に無効。
// - Session Replay / Tracing は導入しない(可観測性強化フェーズで別途検討)。

import * as Sentry from '@sentry/react';

const DSN = (process.env.REACT_APP_SENTRY_DSN || '').trim();

const EMAIL_PATTERN = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;

function redactText(value: string): string {
  return value.replace(EMAIL_PATTERN, '***@***');
}

function redactEvent(event: Sentry.ErrorEvent): Sentry.ErrorEvent {
  if (event.message) event.message = redactText(event.message);
  for (const exception of event.exception?.values ?? []) {
    if (exception.value) exception.value = redactText(exception.value);
  }
  // 念のためURLクエリも落とす(トークン類の混入防止)。
  if (event.request?.url) {
    event.request.url = event.request.url.split('?')[0];
  }
  if (event.request?.query_string) delete event.request.query_string;
  return event;
}

if (DSN) {
  Sentry.init({
    dsn: DSN,
    environment:
      (process.env.REACT_APP_SENTRY_ENVIRONMENT || '').trim() ||
      process.env.NODE_ENV ||
      'development',
    release: process.env.REACT_APP_RELEASE || undefined,
    sendDefaultPii: false,
    // ブラウザ拡張由来の既知ノイズは送らない(ignoredPromiseRejectionsと同方針)。
    ignoreErrors: [
      'message channel closed before a response was received',
      'message port closed before a response was received',
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
    ],
    beforeSend(event) {
      return redactEvent(event);
    },
  });
}

export { Sentry };
